import React from 'react';

// spec-row and quiz glyphs for the v2 /products page, drawn to match the 2026-08 pricing
// prototype. one per spec so the rows line up across cards (battery against battery).

const stroke = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

export type PlpSpecIcon = 'link' | 'feather' | 'batt' | 'magic' | 'collar' | 'shield' | 'satellite' | 'vibe';

export const PlpIcon: React.FC<{ name: PlpSpecIcon }> = ({ name }) => {
  switch (name) {
    case 'link':
      return (
        <svg viewBox="0 0 24 24" {...stroke} aria-hidden="true">
          <path d="M10 13.5a4 4 0 0 0 5.7.3l2.6-2.6a4 4 0 0 0-5.7-5.7l-1.5 1.5" />
          <path d="M14 10.5a4 4 0 0 0-5.7-.3l-2.6 2.6a4 4 0 0 0 5.7 5.7l1.5-1.5" />
        </svg>
      );
    case 'feather':
      return (
        <svg viewBox="0 0 24 24" {...stroke} aria-hidden="true">
          <path d="M20 4c-6 0-11 3.5-13 9l-3 7 7-3c5.5-2 9-7 9-13Z" />
          <path d="M11 13h5M8 16l7-7" />
        </svg>
      );
    case 'batt':
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden="true">
          <rect x="2.5" y="7" width="16" height="10" rx="2.5" />
          <path d="M21 11v2" />
          <path d="M11.5 9.5 8 13h3l-.5 2.5L14 12h-3l.5-2.5Z" fill="currentColor" stroke="none" />
        </svg>
      );
    case 'magic':
      return (
        <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path d="M7.5 1L9.2 5.8L14 7.5L9.2 9.2L7.5 14L5.8 9.2L1 7.5L5.8 5.8L7.5 1Z" />
          <path d="M15 8L16 11L19 12L16 13L15 16L14 13L11 12L14 11L15 8Z" />
          <path d="M16 1L16.6 3L18.5 3.5L16.6 4L16 6L15.4 4L13.5 3.5L15.4 3L16 1Z" />
        </svg>
      );
    case 'collar':
      return (
        <svg viewBox="0 0 24 24" {...stroke} aria-hidden="true">
          <path d="M4 9.5a8 8 0 0 0 16 0" />
          <path d="M4 9.5V8M20 9.5V8" />
          <rect x="9.5" y="12.5" width="5" height="6" rx="1.6" />
        </svg>
      );
    case 'shield':
      return (
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M5 4h14v8.5c0 4.2-3.2 6.9-7 8.5-3.8-1.6-7-4.3-7-8.5V4Z" />
          <circle cx="9.5" cy="8" r="1" fill="#fff" />
          <circle cx="14.5" cy="8" r="1" fill="#fff" />
          <circle cx="12" cy="11.5" r="1" fill="#fff" />
          <circle cx="9.5" cy="15" r="1" fill="#fff" />
          <circle cx="14.5" cy="15" r="1" fill="#fff" />
        </svg>
      );
    case 'satellite':
      return (
        <svg viewBox="0 0 24 24" {...stroke} aria-hidden="true">
          <circle cx="12" cy="16" r="3" />
          <path d="M12 9.5V13" />
          <path d="M7.4 7.4a6.5 6.5 0 0 1 9.2 0" />
          <path d="M4.6 4.6a10.5 10.5 0 0 1 14.8 0" />
        </svg>
      );
    case 'vibe':
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          aria-hidden="true"
        >
          <rect x="9" y="4" width="6" height="16" rx="2" />
          <path d="M4.5 9v6M2 10.5v3M19.5 9v6M22 10.5v3" />
        </svg>
      );
  }
};

/** The mark on a quiz prompt, the same one the PDP's inline prompt carries. */
export const QuizSpark: React.FC = () => (
  <svg viewBox="0 0 24 24" {...stroke} strokeWidth={2.2} aria-hidden="true">
    <path d="M12 3v3M12 18v3M3 12h3M18 12h3M6.3 6.3l2.1 2.1M15.6 15.6l2.1 2.1M17.7 6.3l-2.1 2.1M8.4 15.6l-2.1 2.1" />
  </svg>
);
